import { call, put, takeLatest } from "redux-saga/effects";
import { presetsAPI } from "../api/api";
import { PresetsActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() => presetsAPI.getSubsidiaries());

        yield put({
            type: PresetsActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: PresetsActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(PresetsActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}
